// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "memory-worker" + "." + "40a18798150b21e51976" + ".js";
};